//custom action for checking whether context widget is part of the corporate site
export function chatBotCommands(sirenAction, widgetId, currentPath) {
    return dispatch => {
        if (window.botSDK && sirenAction?.properties?.value) {
            window.botSDK[sirenAction?.properties.value]();
        }
    };
}
